import React from 'react';

export type RouletteMode = 'SOLO' | 'DUO' | 'EQUAL' | 'TREAT';

export interface RouletteModeIconProps {
    mode: RouletteMode;
    size?: number;
    spinning?: boolean; // 릴 회전 중 흐릿한 효과
}

const RouletteModeIcon: React.FC<RouletteModeIconProps> = ({ mode, size = 48, spinning }) => {
    const style: React.CSSProperties = spinning
        ? { filter: 'blur(0.5px)', transform: 'scale(0.95)' }
        : {};
    return (
        <svg width={size} height={size} viewBox="0 0 64 64" style={style}>
            {mode === 'SOLO' && <SoloIcon />}
            {mode === 'DUO' && <DuoIcon />}
            {mode === 'EQUAL' && <EqualIcon />}
            {mode === 'TREAT' && <TreatIcon />}
        </svg>
    );
};

// 🎯 SOLO — 과녁 + 화살
const SoloIcon = () => (
    <g>
        <circle cx="32" cy="32" r="28" fill="#EB5757" />
        <circle cx="32" cy="32" r="22" fill="#fff" />
        <circle cx="32" cy="32" r="16" fill="#EB5757" />
        <circle cx="32" cy="32" r="10" fill="#fff" />
        <circle cx="32" cy="32" r="4" fill="#F2C94C" />
        {/* 화살 */}
        <g>
            <line x1="8" y1="56" x2="30" y2="34" stroke="#333" strokeWidth="2.5" strokeLinecap="round" />
            <polygon points="32,32 36,28 38,38 28,36" fill="#333" />
            <polygon points="6,54 11,57 8,62 3,59" fill="#ccc" />
        </g>
    </g>
);

// ✌️ DUO — 두 반 원 (파랑/주황)
const DuoIcon = () => (
    <g>
        <circle cx="32" cy="32" r="28" fill="#fff" stroke="#333" strokeWidth="1.5" />
        <path d="M32 4 A28 28 0 0 1 32 60 Z" fill="#F2994A" />
        <path d="M32 4 A28 28 0 0 0 32 60 Z" fill="#56CCF2" />
        {/* 두 사람 머리 */}
        <circle cx="21" cy="22" r="4" fill="#fff" />
        <circle cx="43" cy="22" r="4" fill="#fff" />
        {/* 가운데 등호 */}
        <rect x="27" y="38" width="10" height="2" fill="#fff" rx="1" />
        <rect x="27" y="42" width="10" height="2" fill="#fff" rx="1" />
        {/* 중앙 구분선 */}
        <line x1="32" y1="4" x2="32" y2="60" stroke="#fff" strokeWidth="2" />
    </g>
);

// 🤝 EQUAL — N명 원형 배치 + ÷N
const EqualIcon = () => (
    <g>
        <circle cx="32" cy="32" r="28" fill="#EBF3FD" />
        {/* 4명의 머리 */}
        <circle cx="32" cy="10" r="6" fill="#56CCF2" />
        <circle cx="54" cy="32" r="6" fill="#6FCF97" />
        <circle cx="32" cy="54" r="6" fill="#F2994A" />
        <circle cx="10" cy="32" r="6" fill="#BB6BD9" />
        {/* 연결 선 */}
        <line x1="32" y1="16" x2="48" y2="32" stroke="#bbb" strokeWidth="1.2" strokeDasharray="2 2" />
        <line x1="48" y1="32" x2="32" y2="48" stroke="#bbb" strokeWidth="1.2" strokeDasharray="2 2" />
        <line x1="32" y1="48" x2="16" y2="32" stroke="#bbb" strokeWidth="1.2" strokeDasharray="2 2" />
        <line x1="16" y1="32" x2="32" y2="16" stroke="#bbb" strokeWidth="1.2" strokeDasharray="2 2" />
        {/* 중앙 ÷N */}
        <text x="32" y="37" textAnchor="middle" fontSize="14" fontWeight="700" fill="#333" fontFamily="sans-serif">
            ÷N
        </text>
    </g>
);

// 🎁 TREAT — 선물상자 + 리본
const TreatIcon = () => (
    <g>
        {/* 상자 본체 */}
        <rect x="6" y="26" width="52" height="34" fill="#EB5757" rx="3" />
        {/* 뚜껑 */}
        <rect x="4" y="20" width="56" height="12" fill="#C0392B" rx="2" />
        {/* 세로 리본 */}
        <rect x="28" y="20" width="8" height="40" fill="#F2C94C" />
        {/* 가로 리본 */}
        <rect x="4" y="26" width="56" height="5" fill="#F2C94C" />
        {/* 나비 매듭 */}
        <ellipse cx="22" cy="20" rx="10" ry="6" fill="#F2C94C" transform="rotate(-15 22 20)" />
        <ellipse cx="42" cy="20" rx="10" ry="6" fill="#F2C94C" transform="rotate(15 42 20)" />
        <circle cx="32" cy="20" r="4" fill="#E6A800" />
        {/* 상자 반짝임 */}
        <circle cx="14" cy="38" r="1.5" fill="#fff" opacity="0.6" />
        <circle cx="50" cy="50" r="1" fill="#fff" opacity="0.5" />
    </g>
);

export default RouletteModeIcon;
